import { useCallback } from 'react';
import * as Cesium from 'cesium';
import { usePickTerrainPosition } from './common/useCesiumInteraction';
// Comment pins are rendered as HTML overlays (see CommentHtmlPin.tsx) so
// this hook no longer manages Cesium billboard entities or hover/select
// state. The only Cesium-side concern that remains is terrain picking when
// the user clicks an empty map area with the comment tool armed, to drop a
// new pin at a real-world coordinate.
export const useCommentPins = ({ viewer, isToolActive, artifactEntityIdToArtifactId, onDropPin, }) => {
    const pickTerrainPosition = usePickTerrainPosition(viewer);
    const handleMapClick = useCallback((event) => {
        if (!isToolActive || !viewer || viewer.isDestroyed())
            return false;
        const position = pickTerrainPosition(event.position);
        if (!position)
            return false;
        const cart = Cesium.Cartographic.fromCartesian(position);
        const drop = {
            latitude: Cesium.Math.toDegrees(cart.latitude),
            longitude: Cesium.Math.toDegrees(cart.longitude),
            height: cart.height,
            screenPosition: { x: event.position.x, y: event.position.y },
        };
        // If the click landed on a non-comment feature, capture the underlying
        // artifact ID so the new comment auto-links to it. The mapping is
        // provided by the caller (MapViewer) since only it knows the full
        // feature picker chain.
        if (artifactEntityIdToArtifactId) {
            const picked = viewer.scene.pick(event.position);
            if ((picked === null || picked === void 0 ? void 0 : picked.id) && typeof picked.id === 'object' && 'id' in picked.id) {
                const entityId = picked.id.id;
                if (entityId) {
                    const artifactId = artifactEntityIdToArtifactId(entityId);
                    if (artifactId)
                        drop.artifactIdAtClick = artifactId;
                }
            }
        }
        onDropPin(drop);
        return true;
    }, [isToolActive, viewer, pickTerrainPosition, onDropPin, artifactEntityIdToArtifactId]);
    return {
        handleMapClick,
    };
};
